'use strict';

angular.module('linagora.esn.sync')

  .component('syncSidebar', {
    template: require('./sidebar.pug')
  });
